import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { jsx } from '@emotion/react';
import { TouchTarget } from '../TouchTarget/TouchTarget.js';

const baseStyles = () => ({
  fontFamily: "default",
  position: "relative",
  background: "none",
  color: "foreground.action",
  border: "none",
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  cursor: "pointer",
  transition: _ref => {
    let {
      transitions
    } = _ref;
    return transition(transitions.default, "color", "box-shadow");
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  "&:hover": {
    color: "foreground.action.hover"
  },
  "&:active": {
    color: "foreground.action.active"
  },
  "&:focus": {
    outline: "none",
    boxShadow: "focus"
  },
  "&:focus:not([data-focus-visible-added])": {
    boxShadow: "none"
  }
});
const variantStyles = {
  icon: {
    borderRadius: "sm",
    lineHeight: 0
  },
  link: {
    textDecoration: "none",
    borderBlockEnd: "1px solid",
    borderRadius: 0,
    cursor: "pointer",
    fontSize: "inherit",
    borderBlockEndStyle: "dashed",
    borderBlockEndColor: "foreground.action",
    "&:hover": {
      borderBlockEndColor: "foreground.action.hover"
    },
    "&:active": {
      borderBlockEndColor: "foreground.action.active"
    }
  }
};
const ThemedButton = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480"
} : {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480",
  label: "ThemedButton"
})(baseStyles, _ref2 => {
  let {
    variant = "icon"
  } = _ref2;
  return variantStyles[variant];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const ThemedInfoButton = TouchTarget.withComponent(ThemedButton, process.env.NODE_ENV === "production" ? {
  target: "e153n8481"
} : {
  target: "e153n8481",
  label: "ThemedInfoButton"
});
const InfoButton = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    variant = "icon",
    as,
    ...props
  } = _ref3;
  const component = jsx(ThemedInfoButton, _extends({
    as: as,
    ref: forwardedRef,
    variant: variant
  }, props));
  return component;
});
const INFO_BUTTON_VARIANTS = ["icon", "link"];

export { INFO_BUTTON_VARIANTS, InfoButton };
